import { createI18n } from 'vue-i18n'
// import router from '../router'
// 載入語言
// import tw from '@/locales/tw.json'
// import en from '@/locales/en.json'
import en from '../../public/locales/en.json'
import tw from '../../public/locales/tw.json'
import cn from '../../public/locales/cn.json'
// import { useRoute } from 'vue-router'

// const paramsLang = this.$route.params.lang
// const route = useRoute()
// const id = route.params.id
const i18n = createI18n({
  // locale: process.env.VUE_I18N_LOCALE,
  // fallbackLocale: process.env.VUE_I18N_FALLBACK_LOCALE,
  // legacy: false,
  locale: localStorage.getItem("locale") ?? 'en', // 設定語言
  fallbackLocale: 'en', // 若選擇的語言缺少翻譯則退回的語言
  messages: {
    tw,
    en,
    cn
  }
  // messages: loadLocaleMessages()
})
console.log('i18n.js', i18n.global.locale)
export default i18n